import React from 'react';
interface AnimatedStepTransitionProps {
  children: React.ReactNode;
  isAnimating: boolean;
  direction: 'forward' | 'backward';
}
export const AnimatedStepTransition: React.FC<AnimatedStepTransitionProps> = ({
  children,
  isAnimating,
  direction
}) => {
  return <div className={`transition-all duration-500 ease-in-out ${isAnimating ? direction === 'forward' ? 'opacity-0 transform translate-x-8' : 'opacity-0 transform -translate-x-8' : 'opacity-100 transform translate-x-0'}`} data-id="element-716">
      {children}
    </div>;
};